import React from 'react';
import {
  Box,
  Grid,
  Paper,
  Typography,
} from '@material-ui/core';
import {
  Description as DescriptionIcon,
  AccountCircle as AccountCircleIcon,
  AccessTime as AccessTimeIcon,
  EventAvailable as EventAvailableIcon,
  LocalOffer as LocalOfferIcon,
} from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';

import styles from './ResultDetailsHeader.styles';
import { ResultDetailsInfo } from '../types';
import getPatientFullAge from '../../patient/utils';
import getPersonDisplayName from '../../person/utils';

const useStyles = makeStyles(styles);

type Props = {
  resultDetails?: ResultDetailsInfo;
};

const ResultDetailsHeader: React.FC<Props> = ({
  resultDetails,
}: Props) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Paper classes={{ root: classes.details }} square>
        <Grid item container spacing={2}>
          <Grid item container xs={12} sm={5} md={3} alignItems="center">
            <DescriptionIcon color="primary" />
            <Typography variant="body1" classes={{ root: classes.desDetails }}>
              {' Lab No. : '}
              {resultDetails?.requestInfo.labNumber}
            </Typography>
          </Grid>
          <Grid item container xs={12} sm={7} md={6} alignItems="center">
            <AccountCircleIcon color="primary" />
            <Typography variant="body1" classes={{ root: classes.desDetails }}>
              {' Name : '}
              {getPersonDisplayName(resultDetails?.requestInfo.patient?.person)}
            </Typography>
          </Grid>
          <Grid item container xs={12} sm={5} md={3} alignItems="center">
            <AccessTimeIcon color="primary" />
            <Typography variant="body1" classes={{ root: classes.desDetails }}>
              {' Age : '}
              {getPatientFullAge(resultDetails?.requestInfo.age)}
            </Typography>
          </Grid>
          <Grid item container xs={12} sm={5} md={4} alignItems="center">
            <EventAvailableIcon color="primary" />
            <Typography variant="body1" classes={{ root: classes.desDetails }}>
              {' Date / Time : '}
              {moment(resultDetails?.requestInfo.date as Date).format('DD/MM/YYYY hh:mm A')}
            </Typography>
          </Grid>
          <Grid item container xs={12} sm={5} md={4} alignItems="center">
            <LocalOfferIcon color="action" />
            <Typography variant="body1" classes={{ root: classes.desDetails }}>
              {' Ref.1 / H.N : '}
              {resultDetails?.requestInfo.patient?.reference?.ref1}
            </Typography>
          </Grid>
          <Grid item container xs={12} sm={5} md={4} alignItems="center">
            <LocalOfferIcon color="action" />
            <Typography variant="body1" classes={{ root: classes.desDetails }}>
              {' Request No. : '}
              {resultDetails?.requestInfo.reqNumber}
            </Typography>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default ResultDetailsHeader;
